// eslint-disable-next-line ember/no-mixins
import { tracked } from '@glimmer/tracking';
import BillingItemMixin from 'client-portal/mixins/polymorphic/billing-item';
import Model, { attr } from '@ember-data/model';

export default class ReceiptModel extends Model.extend(BillingItemMixin) {
  @attr() displayName;
  @attr('moment') createdAt;
  @attr('boolean') isNewForClient;

  @tracked opened = false;

  get isUnread() {
    return !this.opened && this.isNewForClient;
  }
}
